// Tiny cross-component event bus so any page (e.g. the public RepairsPage) can
// tell the Header to open the login/register modal, which owns that UI state.

export const OPEN_AUTH_MODAL_EVENT = 'edytech:open-auth-modal';

export type AuthModalMode = 'login' | 'register';

export function openAuthModal(mode: AuthModalMode = 'login') {
  window.dispatchEvent(
    new CustomEvent<AuthModalMode>(OPEN_AUTH_MODAL_EVENT, { detail: mode })
  );
}

// Subscribe to auth-open events. Returns an unsubscribe function.
export function onOpenAuthModal(
  handler: (mode: AuthModalMode) => void
): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<AuthModalMode>).detail ?? 'login');
  window.addEventListener(OPEN_AUTH_MODAL_EVENT, listener);
  return () => window.removeEventListener(OPEN_AUTH_MODAL_EVENT, listener);
}